import {Component, inject} from '@angular/core';
import {DarkModeService} from '../../core/services/dark-mode-service';

@Component({
  selector: 'dm-site-under-maintenance',
  imports: [],
  templateUrl: './site-under-maintenance.html',
  styleUrl: './site-under-maintenance.scss',
})
export class SiteUnderMaintenance {
  darkModeService: DarkModeService = inject(DarkModeService);
}
